<template>
  <footer class="footer">
    <b-container fluid>
      <b-row align-v="center">
        <b-col sm="12" md="2">
          <b-row class="footer__social" align-v="center">
            <b-col
              sm="12"
              class="d-flex justify-content-lg-end justify-content-xl-end justify-content-center align-items-center"
            >
              <div class="mr-2">Connect with us</div>
              <a
                href="https://www.linkedin.com/company/greenmark-partners-inc"
                class="footer__social--link"
                title="GreenMark Partners"
                target="_blank"
              >
                <img
                  class="footer__social--icon"
                  src="../../../../ui/public/LI-In-Bug.png"
                  alt="LinkedIn"
                />
              </a>
            </b-col>
          </b-row>
        </b-col>
        <b-col sm="12" md="8">
          <div class="footer__branding">
            <!--<img src="../app/public/greenmark-logo.png" alt="GreenMark Partners logo" />-->
          </div>
          <div class="footer__copyright">
            &copy; copyright {{ currentYear }} &nbsp;|&nbsp; A product by
            Phairify&nbsp;|&nbsp;
            <a
              href="https://phairify-docs.s3.us-east-2.amazonaws.com/Phairify_Privacy_Policy_2020_09_01.pdf"
              target="_blank"
              >Privacy Policy</a
            >
            &nbsp;|&nbsp;
            <a
              href="https://phairify-docs.s3.us-east-2.amazonaws.com/Phairify_Terms_Conditions_Use.pdf"
              target="_blank"
            >
              Terms of Service </a
            >&nbsp;|&nbsp;
            <a
              href="https://phairify-docs.s3.us-east-2.amazonaws.com/Phairify_Accessibility_Statement_2020_09_01.pdf"
              target="_blank"
            >
              Accessibility Statement </a
            >&nbsp;|&nbsp;
            <a href="mailto:support@phairify.com" target="_blank">
              Contact Support
            </a>
          </div>
        </b-col>
        <b-col sm="12" md="2">
          <div class="footer__copyright">{{ currAppVersion }}</div>
        </b-col>
      </b-row>
    </b-container>
  </footer>
</template>

<script>
export default {
  name: 'FooterLayout',
  computed: {
    currAppVersion: function () {
      return process.env.VUE_APP_VERSION;
    },
    currentYear: function () {
      return new Date().getFullYear();
    },
  },
};
</script>

<style scoped></style>
